import { useQueryClient } from '@tanstack/react-query';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle, PageWrapper, Spinner } from '../../../components';
import { useHeroToast, useWarmup } from '../../../hooks';
import { usePostAttractionFirestore } from '../../../queries';
import { AttractionsFirestoreDocumentRequest } from '../../../types';
import { AttractionWizard } from '../components';

export const AttractionCreate:FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: create, isPending: createPending } = usePostAttractionFirestore();
  // Zimny start v3-createAttraction potrafi kosztować kilka sekund — grzejemy
  // funkcję przy wejściu na formularz, zanim user kliknie „Zapisz” (§5).
  useWarmup('v3-createAttraction');
  const { showError, showSuccess } = useHeroToast();
  const handleSubmit = async (
    data: AttractionsFirestoreDocumentRequest,
  ): Promise<void> => {
    create(
      { data: { ...data, baseLang: 'pl' } },
      {
        onSuccess: () => {
          showSuccess('New attraction added successfully!');
          navigate('/attractions');
          queryClient.resetQueries({
            queryKey: ['attractions'],
            exact: true,
          });
        },
        onError: () => {
          showError('Something went wrong. The attraction wasn\'t created.');
        },
      },
    );
  };
  if (createPending) {
    return <Spinner global />;
  }

  return (
    <PageWrapper>
      <PageTitle title="Create Attraction" />
      <AttractionWizard
        onSubmit={handleSubmit}
      />
    </PageWrapper>
  );
};
